// Video sources of « Séance », per exercise name. Only QUALIFIED sources live here; nothing is invented, and a source is never
// reused for another exercise. Exercises without an entry show « Vidéo de démonstration à venir ».
// Two kinds (discriminated by `provider`):
// - "youtube": official YouTube embed URL as observed on the author's page (played in the official iframe, YouTube controls).
// - "file": a qualified .mp4 / .webm file, played by the native VideoPlayer (video-player.tsx). None today.
// To plug a future source, add one entry here; no other change is needed.

export type VideoSource =
  | { provider: "youtube"; videoId: string; embedUrl: string; credit: string; page: string; source: string; note?: string }
  | { provider: "file"; src: string; type?: "video/mp4" | "video/webm"; credit?: string; source: string };

// All five are EXTERNAL demonstrations (not ACS, no validated ACS prescription), sources observed by Root on 12/10. embedUrl is
// the official /embed/<id> URL; the player adds ?playsinline=1&rel=0. One clip per exercise, never reused.
export const EXERCISE_VIDEOS: Record<string, VideoSource> = {
  "Squat gobelet": {
    provider: "youtube", videoId: "RyzecxZlc2o", embedUrl: "https://www.youtube.com/embed/RyzecxZlc2o",
    credit: "Démonstration externe · WhitecoatTrainer", page: "https://whitecoattrainer.com/blog/goblet-squat",
    source: "Embed YouTube observé par Root sur l'article WhitecoatTrainer « goblet squat » (lien 8), 12/10",
  },
  "Soulevé de terre roumain": {
    provider: "youtube", videoId: "JCPd_L-xI5k", embedUrl: "https://www.youtube.com/embed/JCPd_L-xI5k",
    credit: "Démonstration externe · WhitecoatTrainer", page: "https://whitecoattrainer.com/blog/romanian-deadlift",
    source: "Embed YouTube observé par Root (HTTP 200) sur l'article WhitecoatTrainer « romanian deadlift », copie /private/tmp/rdl-source.html, 12/10",
    note: "Variante à la barre ; ta séance se fait aux haltères.",
  },
  "Fentes arrière alternées": {
    provider: "youtube", videoId: "c-NXbe6fShU", embedUrl: "https://www.youtube.com/embed/c-NXbe6fShU",
    credit: "Démonstration externe · John Meadows", page: "https://mountaindogdiet.com/author/john-meadows/page/28/",
    source: "Vidéo YouTube primaire de John Meadows « Exercise Index: Reverse Lunges », référencée sur mountaindogdiet.com (auteur, page 28), observée par Root, 12/10",
    note: "Variante avec appui.",
  },
  "Hip thrust au banc": {
    provider: "youtube", videoId: "RjWiwq1wgFg", embedUrl: "https://www.youtube.com/embed/RjWiwq1wgFg",
    credit: "Démonstration externe · Bret Contreras", page: "https://www.youtube.com/watch?v=RjWiwq1wgFg",
    source: "Vidéo YouTube « How to do the American Hip Thrust », chaîne vérifiée de Bret Contreras, observée par Root, 12/10",
    note: "Variante « American hip thrust » au banc.",
  },
  "Gainage planche": {
    provider: "youtube", videoId: "Vdcy7VrRluA", embedUrl: "https://www.youtube.com/embed/Vdcy7VrRluA",
    credit: "Démonstration externe · ACE (Jonathan Ross)", page: "https://www.acefitness.org/resources/everyone/exercise-library/video/",
    source: "Iframe 45 de la vidéothèque ACE (« Plank School », Jonathan Ross), observée par Root, 12/10",
  },
};

export const exerciseVideo = (name: string): VideoSource | undefined => EXERCISE_VIDEOS[name];
